import { IFeature } from 'mod/featureV2/interface';

export const stickyTopBar: IFeature = {
    moduleId: 'stickyTopBar',
    type: 'stickyTopBar',
    config: {
        name: 'stickyTopBar',
    },
    space: {
        marginTop: 0,
        marginBottom: 0,
        paddingTop: 13,
        paddingBottom: 13,
    },
};

export const stickyTopBar2: IFeature = {
    ...stickyTopBar,
    moduleId: 'stickyTopBar2',
    config: {
        ...stickyTopBar.config,
        name: 'stickyTopBar background opacity',
        disableActions: [],
        addToCartBtnProps: {
            type: 'a'
        },
        buyNowBtnProps: {
            type: 'b'
        },
    },
    background: {
        color: 'rgba(0, 0, 0, 0.8)',
    },
    vars: {
        '--feature-color-default': '#fff',
    }
};